import { render, staticRenderFns } from "./MessageTypeSystemForwardSingleMessage.vue?vue&type=template&id=280cd094&scoped=true&"
import script from "./MessageTypeSystemForwardSingleMessage.vue?vue&type=script&lang=js&"
export * from "./MessageTypeSystemForwardSingleMessage.vue?vue&type=script&lang=js&"
import style0 from "./MessageTypeSystemForwardSingleMessage.vue?vue&type=style&index=0&id=280cd094&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280cd094",
  null
  
)

export default component.exports